<div class="ai-action-dialog" cdkDrag>
  <div class="dialog-title-bar" cdkDragHandle>
    <h2>{{ data.actionDisplayName }}</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    @if (resolutions$ | async; as resolutions) {
      @for (resolution of resolutions; track resolution.statement; let citationOffset = $index) {
        <div class="fact-check-card">
          <p>
            <span class="label">{{ 'EDITOR.AI_ACTION_DIALOG.STATEMENT' | translate }}:</span>
            {{ resolution.statement }}
          </p>
          <p>
            <span class="label">{{ 'EDITOR.AI_ACTION_DIALOG.ANSWER' | translate }}:</span>
            <span
              class="answer"
              [class.answer-true]="resolution.answer === 'True'"
              [class.answer-false]="resolution.answer === 'False'"
              [class.answer-unclear]="resolution.answer === 'Unclear'"
            >
              {{ getAnswerTranslationKey(resolution.answer) | translate }}
            </span>
          </p>
          <p>
            <span class="label">{{ 'EDITOR.AI_ACTION_DIALOG.REASON' | translate }}:</span>
            <span class="reason-container">
              <span class="reason">{{ resolution.reason }}</span>
              @for (citation of resolution.citations; track $index) {
                <span
                  class="citation-badge"
                  [class.citation-call-sentence]="citation.typename === 'CallSentenceCitation'"
                  [class.citation-call-resource]="citation.typename === 'CallResourceCitation'"
                  (click)="onCitationClick(citation)"
                >
                  {{ getCitationIndex(citationOffset, $index) }}
                </span>
              }
            </span>
          </p>
          @if (resolution.answer === 'False' && resolution.newWording !== null) {
            <p>
              <span class="label">{{ 'EDITOR.AI_ACTION_DIALOG.SUGGESTED_WORDING' | translate }}:</span>
              <span class="suggested-wording">{{ resolution.newWording }}</span>
            </p>
          }
        </div>
      }
    } @else {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span class="loading-text">{{ 'EDITOR.CHECKING_FACTS' | translate }}</span>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">{{ 'EDITOR.AI_ACTION_DIALOG.CLOSE' | translate }}</button>
    @if (showInsertButton) {
      <button mat-raised-button color="primary" (click)="accept()">
        {{ 'EDITOR.AI_ACTION_DIALOG.INSERT' | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
